import { handleError } from 'api/utils';
import { createRequest } from 'api/request';

export const getCharges = async (state) => {
  return createRequest(`/v1/charges`, state, {
    method: 'GET',
  }).then((res) => handleError(res));
};
